/* eslint-disable react/no-danger */
// import React, { useEffect } from 'react';
import { NavLink as RRNavLink } from 'react-router-dom';
import { NavLink } from 'reactstrap';
import './interviews.css';
import interviewList from '../../data/interviews.json';

const Interviews = () => (
  <div className="interview-section-container">
    <div className="row">
      {
        interviewList.map((interview) => (
          <div key={interview.title} className="col-md-4 interview-article">
            <NavLink
              tag={RRNavLink}
              to={interview.url}
            >
              <div className="interview-article-image" dangerouslySetInnerHTML={{ __html: interview.image }} />
              <div className="interview-article-title">
                <span dangerouslySetInnerHTML={{ __html: interview.title }} />
              </div>
              <div className="interview-article-description">
                {interview.description}
                <br />
                {interview.customer}
              </div>
            </NavLink>
          </div>
        ))
      }
    </div>

  </div>
);
export default Interviews;
